import React, { useCallback, useEffect, useState } from 'react';
import { useMatches, useNavigate } from 'react-router-dom';

import AccessTime from '@mui/icons-material/AccessTime';
import AvTimer from '@mui/icons-material/AvTimer';
import Avatar from '@mui/material/Avatar';
import Collapse from '@mui/material/Collapse';
import Comment from '@mui/icons-material/Comment';
import Drawer from '@mui/material/Drawer';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Favorite from '@mui/icons-material/Favorite';
import FilterList from '@mui/icons-material/FilterList';
import Launch from '@mui/icons-material/Launch';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ResidentialDining from './ResidentialDiningIcon';

import SimpleBurger from './SimpleBurgerIcon';
import UserPanel from './UserPanel';
import { getDateForParams } from '../utility/index.js';
import moment from 'moment';
import navigationJson from '../utility/navigation.json';
import strings from '../utility/strings.js';

function findWithAttr(array, attr, value) {
  for (var i = 0; i < array.length; i += 1) {
    if (array[i][attr] === value) {
      return i;
    }
  }
  return -1;
}

const Navigation = props => {
  // Props
  const { currentUser, handleDrawer, locations } = props;
  const matches = useMatches();

  const loadOpen = useCallback(() => {
    let activeLocation = locations.map((x) => {
      let isMatch = x.diningCourts.map((y) => {
        return y.name === matches[1].params.locationName;
      });
      if (isMatch.includes(true)) {
        return x.name
      } else {
        return null
      }
    });

    if (activeLocation.filter(n => n)[0] !== undefined) {
      return { active: true, type: activeLocation.filter(n => n)[0] };
    } else {
      return { active: false, type: null };
    };
  }, [locations, matches]);

  // State
  const [width, setWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);
  const [open, setOpen] = useState(loadOpen());

  let navigate = useNavigate();
  let date = matches ? getDateForParams(matches[1].params) : moment();
  let meal = matches && matches[1].params.meal ? matches[1].params.meal : '';

  let currentPath = matches ? matches[1].pathname : '';

  const updateWindowDimensions = useCallback(() => {
    if (typeof window !== "undefined") {
      setWidth(window.innerWidth);
    }
  }, []);

  useEffect(() => {
    loadOpen();
  }, [loadOpen]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      updateWindowDimensions();
      window.addEventListener('resize', updateWindowDimensions);
      return () => {
        window.removeEventListener('resize', updateWindowDimensions);
      };
    }
  }, [updateWindowDimensions]);

  const handleClick = useCallback((action) => {
    props.handleDrawer();
    navigate(action);
  }, [props, navigate])

  const handleOpen = (type) => {
    if (!open.active === true || type !== open.type) {
      setOpen({ active: true, type: type })
    } else {
      setOpen({ active: false, type: null })
    };
  }

  let variant = width < 1224 ? "temporary" : "permanent";

  function returnIcon(value) {
    if (value === 'burger') {
      return <SimpleBurger className="c-md-icon" />
    } else if (value === 'residential') {
      return <ResidentialDining className="c-md-icon" />
    } else if (value === 'clock') {
      return <AccessTime className="c-md-icon" />
    } else if (value === 'heart') {
      return <Favorite className="c-md-icon" />
    } else if (value === 'timer') {
      return <AvTimer className="c-md-icon" />
    } else if (value === 'settings') {
      return <FilterList className="c-md-icon" />
    } else if (value === 'comment') {
      return <Comment className="c-md-icon" />
    } else if (value === 'external') {
      return <Launch className="c-md-icon" />
    }
  }


  let navigationListItems = navigationJson.map((x) => {
    if (x.type === 'nav') {
      return <ListItemButton key={x.title} className={currentPath === x.path ? 'md-drawer-navigation__item active' : 'md-drawer-navigation__item'} onClick={() => handleClick(x.path)}>
        <ListItemIcon>
          {returnIcon(x.icon)}
        </ListItemIcon>
        <ListItemText primary={x.title} />
      </ListItemButton>
    } else if (x.type === 'external') {
      return <a key={x.title} className="md-drawer-navigation__item" href={x.path}>
        <ListItem className="md-drawer-navigation__item">
          <ListItemIcon>
            {returnIcon(x.icon)}
          </ListItemIcon>
          <ListItemText primary={x.title} />
        </ListItem>
      </a>
    } else if (x.type === 'group') {
      let index = matches[1].params.locationName && locations.diningCourts ? findWithAttr(locations.diningCourts, 'name', matches[1].params.locationName) : -1;
      let activeListItem = index === 1 ? true : false;
      return <div key={x.title}>
        <ListItemButton key={x.title + "-button"} className={activeListItem ? "md-drawer-navigation__item active" : "md-drawer-navigation__item"} onClick={() => handleOpen(x.title)}>
          <ListItemIcon>
            {returnIcon(x.icon)}
          </ListItemIcon>
          <ListItemText primary={x.title} />
          {open.active && open.type === x.title ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse key={x.title + "-collapse"} in={open.active && open.type === x.title ? true : false} timeout="auto" unmountOnExit>
          {
            // Use the API locations to load the dining court data and links, navigationJson is just to setup the order of menu items in nav.
            locations ? locations.find(o => o.name === x.title).diningCourts.map((y, i) => {
              let activeItem = y.name === matches[1].params.locationName ? true : false;
              return <ListItemButton key={i} className={`md-drawer-navigation__item-collapse ${activeItem ? "active" : ""}`} onClick={() => handleClick("/" + y.name + date.format("/YYYY/M/D/") + encodeURIComponent(meal))}>
                <ListItemAvatar>
                  <Avatar className="c-md-icon--avatar" alt={y.formalName} src={y.logoUrl} />
                </ListItemAvatar>
                <ListItemText primary={y.formalName} />
              </ListItemButton>;
            }) : null
          }
        </Collapse>
      </div>
    }
    return null; // Add explicit return for map function
  })


  return <Drawer 
    variant={variant} 
    classes={{
      paper: "md-drawer-paper"
    }} 
    className={"md-drawer"} 
    anchor={"left"} 
    open={props.open} 
    onClose={() => handleDrawer()}
  >
    <div
      className="md-drawer-scroll"
      tabIndex={0}
      role="region"
      aria-label="Scrollable navigation menu"
    >
      <nav>
        <UserPanel currentUser={currentUser} triggerDrawerClose={handleDrawer} />
        <List
          component="nav"
          className="md-drawer-navigation"
          role="navigation"
          aria-label="Main navigation menu"
        >
          {navigationListItems}
        </List>

        <div className="md-drawer-footer">
          <a href="https://itunes.apple.com/us/app/purdue-mobile-menus/id456046364" aria-label="Download our dining menus app from the Apple App Store for your iPhone, iPad, or other apple device." className="app-badge"> <div className="ios-badge" style={{
            padding: '.75rem 1rem'
          }} /> </a>
          <a href="https://play.google.com/store/apps/details?id=edu.purdue.dining.menus" aria-label="Download our dining menus app from the Android App Store, Google Play for your andriod devices." className="app-badge"> <div className="android-badge" style={{
            padding: '.75rem 1rem'
          }} /> </a>
        </div>

        <div className={'c-version'}>
          {strings.version}
        </div>
      </nav>
    </div>
  </Drawer>;
};

export default Navigation;